import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import PageTitle from "../ui/PageTitle";
import ToastMsg from "../ui/ToastMsg";
import useApp from "../../utils/useApp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed,
  faBoxesStacked,
  faBriefcase,
  faBuilding,
  faBullseye,
  faClipboardQuestion,
  faFileText,
  faHouseChimney,
  faUsers,
  faShieldHalved,
  faThumbTack,
  faUsersLine,
} from "@fortawesome/free-solid-svg-icons";
import OrgGoalTemplates from "./goaltemplates/OrgGoalTemplates";
import OrgDetails from "./details/OrgDetails";
import useMenuToggle from "../../utils/useMenuToggle";
import OrgPrograms from "./programs/OrgPrograms";
import OrgJobs from "./jobs/OrgJobs";
import OrgFields from "./fields/OrgFields";
import OrgCustomAssessments from "./assessments/OrgCustomAssessments";
import OrgBedManagement from "./beds/OrgBedManagement";
import OrgDwellingManagement from "./beds/OrgDwellingManagement";
import OrgFacilityManagement from "./beds/OrgFacilityManagement";
import OrgCustomNoteTypes from "./notes/OrgCustomNoteTypes";
import OrgResources from "./resources/OrgResources";
import Users from "../users/Users";

const Settings = () => {
  const { showMenu, auth }: any = useApp();
  const toggleMenu = useMenuToggle();
  const location = useLocation();
  const initialTab: string =
    location.state?.tab === "users" ? "users" : "details";
  const isAdmin = auth?.profile?.role === "admin";
  const [activeTab, setActiveTab] = useState<string>(initialTab);
  const [facilityUpdated, setFacilityUpdated] = useState<boolean>(false);
  const [roomsUpdated, setRoomsUpdated] = useState<boolean>(false);
  const [orgToSave, setOrgToSave] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");
  const searchRef = useRef<HTMLInputElement>(null);

  const onNavClick = (route: string) => {
    setActiveTab(route);
  };

  return (
    <>
      <ToastMsg
        showToast={showToast}
        setShowToast={setShowToast}
        toastText={toastText}
        toastBody={toastBody}
      />

      <Container
        className={
          showMenu
            ? "lg div-main-menu custom-container container-edge-fixed px-5"
            : "lg div-main custom-container container-edge-fixed px-5"
        }
      >
        <Tab.Container defaultActiveKey={initialTab}>
          <Row>
            <Col sm={toggleMenu ? 2 : 1}>
              <Nav
                variant="pills"
                className={
                  showMenu
                    ? "flex-column sticky-top mycase-menu-open-sticky"
                    : "flex-column sticky-top mycase-menu-sticky"
                }
              >
                <Nav.Item className="mb-2">
                  {toggleMenu ? (
                    <PageTitle title={"Organization"} type={"page"} />
                  ) : (
                    <span className="hero-heading font-size-dynamic-heading fw-semibold app-header-text">
                      {"Org"}
                    </span>
                  )}
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="details"
                    className={
                      activeTab === "details"
                        ? "nav-vertical-active nav-slide"
                        : "nav-vertical nav-slide"
                    }
                    onClick={() => onNavClick("details")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <span className="nav-slide-content">
                      <FontAwesomeIcon
                        icon={faBriefcase}
                        fixedWidth
                        className={toggleMenu ? "me-2" : "me-0"}
                      />
                      {toggleMenu ? "Details" : ""}
                    </span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="d-grid">
                  <Nav.Link
                    eventKey="users"
                    className={
                      activeTab === "users"
                        ? "nav-vertical-active nav-slide"
                        : "nav-vertical nav-slide"
                    }
                    onClick={() => onNavClick("users")}
                    disabled={orgToSave === true ? true : false}
                  >
                    <span className="nav-slide-content">
                      <FontAwesomeIcon
                        icon={faUsers}
                        fixedWidth
                        className={toggleMenu ? "me-2" : "me-0"}
                      />
                      {toggleMenu ? "Users" : ""}
                    </span>
                  </Nav.Link>
                </Nav.Item>
                {!isAdmin && (
                  <>
                    <Nav.Item className="d-grid mt-3">
                      {toggleMenu ? (
                        <PageTitle title={"Assignments"} type={"sub-section"} />
                      ) : (
                        <h6 className="hero-heading app-header-text">
                          {"Assign"}
                        </h6>
                      )}
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="programs"
                        className={`${activeTab === "programs" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                        onClick={() => onNavClick("programs")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <span className="nav-slide-content">
                          <FontAwesomeIcon
                            icon={faUsersLine}
                            fixedWidth
                            className={toggleMenu ? "me-2" : "me-0"}
                          />
                          {toggleMenu ? "Programs" : ""}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="jobs"
                        className={`${activeTab === "jobs" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                        onClick={() => onNavClick("jobs")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <span className="nav-slide-content">
                          <FontAwesomeIcon
                            icon={faThumbTack}
                            fixedWidth
                            className={toggleMenu ? "me-2" : "me-0"}
                          />
                          {toggleMenu ? "Jobs" : ""}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="resources"
                        className={`${activeTab === "resources" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                        onClick={() => onNavClick("resources")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <span className="nav-slide-content">
                          <FontAwesomeIcon
                            icon={faBoxesStacked}
                            fixedWidth
                            className={toggleMenu ? "me-2" : "me-0"}
                          />
                          {toggleMenu ? "Resources" : ""}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="d-grid mt-3">
                      {toggleMenu ? (
                        <PageTitle
                          title={"Custom Data Configuration"}
                          type={"sub-section"}
                        />
                      ) : (
                        <h6 className="hero-heading app-header-text">
                          {"Data"}
                        </h6>
                      )}
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="fields"
                        className={`${activeTab === "fields" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                        onClick={() => onNavClick("fields")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <span className="nav-slide-content">
                          <FontAwesomeIcon
                            icon={faShieldHalved}
                            fixedWidth
                            className={toggleMenu ? "me-2" : "me-0"}
                          />
                          {toggleMenu ? "Fields" : ""}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="notes"
                        className={`${activeTab === "notes" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                        onClick={() => onNavClick("notes")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <span className="nav-slide-content">
                          <FontAwesomeIcon
                            icon={faFileText}
                            fixedWidth
                            className={toggleMenu ? "me-2" : "me-0"}
                          />
                          {toggleMenu ? "Notes" : ""}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="goals"
                        className={`${activeTab === "goals" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                        onClick={() => onNavClick("goals")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <span className="nav-slide-content">
                          <FontAwesomeIcon
                            icon={faBullseye}
                            fixedWidth
                            className={toggleMenu ? "me-2" : "me-0"}
                          />
                          {toggleMenu ? "Goal Templates" : ""}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="d-grid">
                      <Nav.Link
                        eventKey="assessments"
                        className={`${activeTab === "assessments" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                        onClick={() => onNavClick("assessments")}
                        disabled={orgToSave === true ? true : false}
                      >
                        <span className="nav-slide-content">
                          <FontAwesomeIcon
                            icon={faClipboardQuestion}
                            fixedWidth
                            className={toggleMenu ? "me-2" : "me-0"}
                          />
                          {toggleMenu ? "Assessments" : ""}
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                    {auth?.profile?.includeHMIS === 1 && (
                      <>
                        <Nav.Item className="d-grid mt-3">
                          {toggleMenu ? (
                            <PageTitle
                              title={"Bed & Property Management"}
                              type={"sub-section"}
                            />
                          ) : (
                            <h6 className="hero-heading app-header-text">
                              {"Bed"}
                            </h6>
                          )}
                        </Nav.Item>
                        <Nav.Item className="d-grid">
                          <Nav.Link
                            eventKey="dwellings"
                            className={`${activeTab === "dwellings" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                            onClick={() => onNavClick("dwellings")}
                            disabled={orgToSave === true ? true : false}
                          >
                            <span className="nav-slide-content">
                              <FontAwesomeIcon
                                icon={faHouseChimney}
                                fixedWidth
                                className={toggleMenu ? "me-2" : "me-0"}
                              />
                              {toggleMenu ? "Dwellings" : ""}
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="d-grid">
                          <Nav.Link
                            eventKey="facilities"
                            className={`${activeTab === "facilities" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                            onClick={() => onNavClick("facilities")}
                            disabled={orgToSave === true ? true : false}
                          >
                            <span className="nav-slide-content">
                              <FontAwesomeIcon
                                icon={faBuilding}
                                fixedWidth
                                className={toggleMenu ? "me-2" : "me-0"}
                              />
                              {toggleMenu ? "Facilities" : ""}
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="d-grid">
                          <Nav.Link
                            eventKey="rooms"
                            className={`${activeTab === "rooms" ? "nav-vertical-active nav-slide" : "nav-vertical nav-slide"}${toggleMenu ? " ps-3" : ""}`}
                            onClick={() => onNavClick("rooms")}
                            disabled={orgToSave === true ? true : false}
                          >
                            <span className="nav-slide-content">
                              <FontAwesomeIcon
                                icon={faBed}
                                fixedWidth
                                className={toggleMenu ? "me-2" : "me-0"}
                              />
                              {toggleMenu ? "Rooms" : ""}
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                      </>
                    )}
                  </>
                )}
              </Nav>
            </Col>
            <Col xs={toggleMenu ? 10 : 11} className="mt-2">
              <Tab.Content>
                <Tab.Pane eventKey="details" className="pb-5">
                  <OrgDetails
                    setOrgToSave={setOrgToSave}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="users" className="pb-5">
                  <Users
                    isActive={activeTab === "users"}
                    setShowToast={setShowToast}
                    setToastText={setToastText}
                    setToastBody={setToastBody}
                  />
                </Tab.Pane>
                {!isAdmin && (
                  <>
                    <Tab.Pane eventKey="programs" className="pb-5">
                      <OrgPrograms
                        setOrgToSave={setOrgToSave}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="jobs" className="pb-5">
                      <OrgJobs
                        setOrgToSave={setOrgToSave}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="fields" className="pb-5">
                      <OrgFields
                        setOrgToSave={setOrgToSave}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="notes" className="pb-5">
                      <OrgCustomNoteTypes
                        setOrgToSave={setOrgToSave}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="goals" className="pb-5">
                      <OrgGoalTemplates
                        isActive={activeTab === "goals"}
                        searchRef={searchRef}
                        setOrgToSave={setOrgToSave}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="assessments" className="pb-5">
                      <OrgCustomAssessments
                        setOrgToSave={setOrgToSave}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="resources" className="pb-5">
                      <OrgResources
                        setOrgToSave={setOrgToSave}
                        setShowToast={setShowToast}
                        setToastText={setToastText}
                        setToastBody={setToastBody}
                      />
                    </Tab.Pane>
                    {auth?.profile?.includeHMIS === 1 && (
                      <>
                        <Tab.Pane eventKey="dwellings">
                          <OrgDwellingManagement
                            setOrgToSave={setOrgToSave}
                            setShowToast={setShowToast}
                            setToastText={setToastText}
                            setToastBody={setToastBody}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="facilities">
                          <OrgFacilityManagement
                            getData={facilityUpdated}
                            setOrgToSave={setOrgToSave}
                            setFacilityUpdated={setFacilityUpdated}
                            setRoomsUpdated={setRoomsUpdated}
                            setShowToast={setShowToast}
                            setToastText={setToastText}
                            setToastBody={setToastBody}
                          />
                        </Tab.Pane>
                        <Tab.Pane eventKey="rooms">
                          <OrgBedManagement
                            getData={roomsUpdated}
                            setOrgToSave={setOrgToSave}
                            setFacilityUpdated={setFacilityUpdated}
                            setRoomsUpdated={setRoomsUpdated}
                            setShowToast={setShowToast}
                            setToastText={setToastText}
                            setToastBody={setToastBody}
                          />
                        </Tab.Pane>
                      </>
                    )}
                  </>
                )}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </>
  );
};

export default Settings;
